import * as yup from 'yup';

const phoneRegExp = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;

const validationSchema = yup.object().shape({
  firstName: yup
    .string()
    .min(1, 'Must have at least one character.')
    .required('Please enter your first name.'),
  lastName: yup
    .string()
    .min(1, 'Must have at least one character')
    .required('Please enter your last name.'),
  email: yup
    .string()
    .email('Please enter a valid email')
    .required('Please enter your email.'),
  phone: yup
    .string()
    .matches(phoneRegExp, 'Please enter a valid email.')
    .required('Please enter your phone number.'),
  companyName: yup
    .string()
    .min(1, 'Must have at least one character')
    .required('Please enter your company name.'),
  comment: yup.string().notRequired(),
});

export default validationSchema;
